/**
 * `/app/widgets/$widgetRef/forms/new` — a new form. The page is
 * `pages/forms/FormEditorPage.tsx`, opened with no form; a static segment, so it wins over
 * `$formKey` — which is why the editor refuses `new` as a key.
 */

import { createFileRoute } from '@tanstack/react-router'

import { NotFound } from '../../../../../errors/NotFound.js'
import { FormEditorPage } from '../../../../../pages/forms/FormEditorPage.js'

export const Route = createFileRoute('/app/widgets/$widgetRef/forms/new')({
  notFoundComponent: NotFound,
  component: NewFormRoute,
})

function NewFormRoute() {
  const { widgetRef } = Route.useParams()
  return <FormEditorPage widgetRef={widgetRef} />
}
